/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/reducerFields.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for Fields
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Wednesday, March 06, 2019 - 08:38:43 PM (CST)
 *  
 *  Notes:
 *
 *  
 *  Revisions:
 *      03/06/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    FIELD_LIST_CONTAINER_LOADED,
    FIELD_LIST_CONTAINER_UNLOADED,
    FIELD_LIST_TABLE_LOADED,
    FIELD_LIST_TABLE_UNLOADED,

    FIELD_LIST_CHANGE_GROUP_SELECT,
    FIELD_LIST_CHANGE_SET_SELECT,

    FIELD_SELECT_ROW,
    FIELD_ADD,
    FIELD_EDIT,
    FIELD_DELETE,
    FIELD_OPEN_WARNING,
    FIELD_CLOSE_WARNING,
    FIELD_DELETE_DISABLE,

    FIELD_EDIT_CONTAINER_LOADED,
    FIELD_EDIT_CONTAINER_UNLOADED,
    FIELD_EDIT_FORM_LOADED,
    FIELD_EDIT_FORM_UNLOADED,
    FIELD_SET_PATHTRAIL,
    FIELD_EDIT_DATA_LOAD,
    FIELD_EDIT_CONTAINER_SUBMIT,
    FIELD_EDIT_CONTAINER_CANCEL
} from '../constants/actionTypeFields';

const defaultState = {
    refreshList: false,
    danger: false,
    fieldid: 0,
    fieldsetgroupid: 0,
    fieldsetid: 0,
    name: '',
    description: '',
    fieldkey: '',
    sqlfield: '',
    orderid: 0,
    createdate: '',
    modifydate: ''
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case FIELD_LIST_CONTAINER_LOADED:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                fields: action.payload[0] ? action.payload[0].records : null,
                fieldsetgroups: action.payload[1] ? action.payload[1].records : null,
                fieldsets: action.payload[2] ? action.payload[2].records : null
            }
        case FIELD_LIST_CHANGE_GROUP_SELECT:
            return {
                ...state,
                fieldsets: action.payload[1] ? action.payload[1].records : null
            }
        case FIELD_LIST_CHANGE_SET_SELECT:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                fields: action.payload[0] ? action.payload[0].records : null,
            }
        case FIELD_LIST_TABLE_LOADED:
            return {
                ...state
            }
        case FIELD_SELECT_ROW:
            return {
                ...state,
                fieldid: action.id
            }
        case FIELD_ADD:
            return {
                ...state
            }
        case FIELD_EDIT:
            return {
                ...state,
                fieldid: action.id
            }
        case FIELD_DELETE:
            return {
                ...state,
                fieldid: null
            }
        case FIELD_DELETE_DISABLE:
            return {
                ...state,
                disableDelete: action.disabled
            }
        case FIELD_OPEN_WARNING:
            return {
                ...state,
                danger: true
            }
        case FIELD_CLOSE_WARNING:
            return {
                ...state,
                danger: false
            }
        case FIELD_EDIT_CONTAINER_LOADED:
            return {
                ...state,
                fieldid: action.payload[0] ? action.payload[0].fieldid : 0,
                fieldsetgroupid: action.payload[0] ? action.payload[0].fieldsetgroupid : 0,
                fieldsetid: action.payload[0] ? action.payload[0].fieldsetid : 0,
                name: action.payload[0] ? action.payload[0].name : '',
                description: action.payload[0] ? action.payload[0].description : '',
                fieldkey: action.payload[0] ? action.payload[0].fieldkey : '',
                sqlfield: action.payload[0] ? action.payload[0].sqlfield : '',
                createdate: action.payload[0] ? action.payload[0].createdate : '',
                modifydate: action.payload[0] ? action.payload[0].modifydate : '',
                fieldsetpath: action.payload[1] ? action.payload[1].records : '',
                fieldset: action.payload[2] ? action.payload[2].name : '',
            }
        case FIELD_EDIT_DATA_LOAD:
            return {
                ...state,
                fieldid: action.payload[0] ? action.payload[0].fieldid : 0,
                fieldsetgroupid: action.payload[0] ? action.payload[0].fieldsetgroupid : 0,
                fieldsetid: action.payload[0] ? action.payload[0].fieldsetid : 0,
                name: action.payload[0] ? action.payload[0].name : '',
                description: action.payload[0] ? action.payload[0].description : '',
                fieldkey: action.payload[0] ? action.payload[0].fieldkey : '',
                sqlfield: action.payload[0] ? action.payload[0].sqlfield : '',
                createdate: action.payload[0] ? action.payload[0].createdate : '',
                modifydate: action.payload[0] ? action.payload[0].modifydate : ''
            }
        case FIELD_SET_PATHTRAIL:
            return {
                ...state,
                pathTrail: action.pathTrail ? action.pathTrail : ''
            }
        case FIELD_EDIT_FORM_LOADED:
            return {
                ...state
            }
        case FIELD_EDIT_CONTAINER_SUBMIT:
            return {
                ...state
            }
        case FIELD_EDIT_CONTAINER_CANCEL:
            return {
                ...state
            }
        case FIELD_LIST_CONTAINER_UNLOADED:
        case FIELD_LIST_TABLE_UNLOADED:
        case FIELD_EDIT_CONTAINER_UNLOADED:
        case FIELD_EDIT_FORM_UNLOADED:
            return {};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/reducerFields.js